function shoppingCartReducer(
  shoppingCart = { isShowing: false, mustRedirect: false, content: [] },
  action,
) {
  switch (action.type) {
    case "MODIFY_CART_CONTENT":
      let cartContentCopy = [...shoppingCart.content];
      for (const product of action.payload) {
        if (cartContentCopy.some((item) => item.id === product.id)) {
          cartContentCopy = cartContentCopy.map((item) =>
            item.id === product.id ? { ...item, quantity: item.quantity + product.quantity } : item,
          );
        } else {
          cartContentCopy = [...cartContentCopy, product];
        }
      }
      return {
        ...shoppingCart,
        content: cartContentCopy.filter((product) => product.quantity > 0),
      };
    case "REMOVE_PRODUCT":
      return {
        ...shoppingCart,
        content: shoppingCart.content.filter((item) => item.id !== action.payload),
      };
    case "CLEAR_CART":
      return { ...shoppingCart, content: [] };
    case "TOGGLE_CART_VISIBILITY":
      return { ...shoppingCart, isShowing: !shoppingCart.isShowing };
    case "TOGGLE_LOGIN_REDIRECTION":
      return { ...shoppingCart, mustRedirect: !shoppingCart.mustRedirect };
    default:
      return shoppingCart;
  }
}

export default shoppingCartReducer;
